import { Outlet } from "@tanstack/react-router";
import { ColumnDirectionAlignStartFlexFill, ColumnDirectionJustifyCenterAlignCenterFlexFill, RowJustifyStartFlex } from "../commons/Containers";
import Navigation from "./Navigation";
import { Alert, Backdrop, CircularProgress, Snackbar, Typography } from "@mui/material";
import { createContext, useEffect, useState } from "react";
import { getAllWABA } from "../../api/Api";

export const BackDropContext = createContext();
export const WABAContext = createContext();
export const SnackBarContext = createContext();

export default function MainLayout({ children }) {

    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [backdropMessage, setBackDropMessage] = useState();
    const [waba, setWaba] = useState([]);
    const [snackBarMessage, setSnackBarMessage] = useState();
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [snackBarLevel, setSnackBarLevel] = useState();

    useEffect(() => {
        getAllWABA().then(list => setWaba(list));
    }, []);

    const closeBackdrop = () => {
        setOpenBackdrop(false);
        setBackDropMessage(null);
    };

    const getAllPhones = () => {
        return waba.flatMap(e => e.phoneNumbers);
    };

    const logToSnackBar = ({ message, level }) => {
        console.log('message');
        setOpenSnackBar(true);
        setSnackBarMessage(message);
        setSnackBarLevel(level);
    };

    const closeSnackBar = () => {
        setSnackBarMessage(null);
        setOpenSnackBar(false);
        setSnackBarLevel('info');
    }

    return (
        <ColumnDirectionAlignStartFlexFill>
            <Navigation />
            <BackDropContext.Provider value={{ setOpenBackdrop, setBackDropMessage, closeBackdrop }}>
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openBackdrop} onClick={closeBackdrop}>
                    <ColumnDirectionJustifyCenterAlignCenterFlexFill gap={2}>
                        <CircularProgress color="inherit" />
                        {backdropMessage && <Typography variant="h6">
                            {backdropMessage}
                        </Typography>}
                    </ColumnDirectionJustifyCenterAlignCenterFlexFill>
                </Backdrop>
                <SnackBarContext.Provider value={{ setOpenSnackBar, logToSnackBar }}>
                    <WABAContext.Provider value={{ waba, getAllPhones }}>
                        <Outlet />
                        <Snackbar open={openSnackBar} anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }} onClose={closeSnackBar} autoHideDuration={5000} >
                            <Alert severity={snackBarLevel} variant="filled" sx={{ width: '100%' }} onClose={closeSnackBar}>{snackBarMessage}</Alert>
                        </Snackbar>
                    </WABAContext.Provider>
                </SnackBarContext.Provider>
            </BackDropContext.Provider>
        </ColumnDirectionAlignStartFlexFill>
    );
}